<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.29576 3.38455C2.5 4.47983 2.5 6.04222 2.5 9.16699V10.8337C2.5 13.9584 2.5 15.5208 3.29576 16.6161C3.55276 16.9698 3.86383 17.2809 4.21756 17.5379C5.31283 18.3337 6.87522 18.3337 10 18.3337C13.1248 18.3337 14.6872 18.3337 15.7824 17.5379C16.1362 17.2809 16.4472 16.9698 16.7042 16.6161C17.5 15.5208 17.5 13.9584 17.5 10.8337V9.16699C17.5 6.04222 17.5 4.47983 16.7042 3.38455C16.4472 3.03083 16.1362 2.71975 15.7824 2.46275C14.6872 1.66699 13.1248 1.66699 10 1.66699C6.87522 1.66699 5.31283 1.66699 4.21756 2.46275C3.86383 2.71975 3.55276 3.03083 3.29576 3.38455ZM6.66667 6.04199C6.32149 6.04199 6.04167 6.32181 6.04167 6.66699C6.04167 7.01217 6.32149 7.29199 6.66667 7.29199H13.3333C13.6785 7.29199 13.9583 7.01217 13.9583 6.66699C13.9583 6.32181 13.6785 6.04199 13.3333 6.04199H6.66667ZM8.33333 9.37533C7.98816 9.37533 7.70833 9.65515 7.70833 10.0003C7.70833 10.3455 7.98816 10.6253 8.33333 10.6253H11.6667C12.0118 10.6253 12.2917 10.3455 12.2917 10.0003C12.2917 9.65515 12.0118 9.37533 11.6667 9.37533H8.33333ZM6.66667 12.7087C6.32149 12.7087 6.04167 12.9885 6.04167 13.3337C6.04167 13.6788 6.32149 13.9587 6.66667 13.9587H13.3333C13.6785 13.9587 13.9583 13.6788 13.9583 13.3337C13.9583 12.9885 13.6785 12.7087 13.3333 12.7087H6.66667Z"
      :fill="color"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    color: {
      type: String,
      default: "white",
    },
  },
})
</script>

<style></style>
